module.exports = __webpack_public_path__ + "static/media/ny-che-small.4672c3c0.png";